
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 51 51","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M50 11.949a.096.096 0 00-.013-.054.12.12 0 00-.042-.042L32.729.032A.136.136 0 0032.643 0a.224.224 0 00-.125.043.088.088 0 00-.037.088v8.898H.611a.687.687 0 00-.432.148.47.47 0 00-.179.358v4.833c0 .134.064.263.179.358a.68.68 0 00.432.148h31.87v8.896c0 .017.005.034.013.05.008.015.02.03.035.041a.149.149 0 00.051.028.198.198 0 00.06.009.138.138 0 00.086-.032l17.219-11.82a.115.115 0 00.042-.043.094.094 0 00.013-.054zM49.389 40.971a.687.687 0 00.432-.148.47.47 0 00.179-.358v-4.83a.466.466 0 00-.179-.358.685.685 0 00-.432-.149h-31.87V26.23a.113.113 0 00-.013-.05.146.146 0 00-.086-.069.198.198 0 00-.06-.009.144.144 0 00-.086.032L.055 37.954a.137.137 0 00-.038.038.106.106 0 00-.012.097c.007.016.016.03.029.043l.021.017 17.216 11.819c.023.02.054.031.086.032a.17.17 0 00.112-.035.118.118 0 00.05-.09v-8.904h31.87z"}})])])
          )
        }
      }
    